module.exports = __webpack_public_path__ + "static/up43-3d3645a1a2c6cfdb5484ca6d43d1811d.png";